import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { createTheme, MantineProvider } from "@mantine/core";
import "@mantine/tiptap/styles.css";
import { ScrollToTop } from "./components/ScrollToTop";
import { Provider as JotaiProvider } from "jotai";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { jotaiStore } from "./store/jotaiStore";
import { Toaster } from "sonner";

const theme = createTheme({
  colors: {
    primary: [
      "#f1f1ff",
      "#e0e0f3",
      "#bebede",
      "#9a9aca",
      "#7b7bb8",
      "#6868ae",
      "#5e5eaa",
      "#4e4e96",
      "#444587",
      "#393b79",
    ],
  },
  fontFamily: "Poppins, sans-serif",
  primaryColor: "primary",
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <JotaiProvider store={jotaiStore}>
      <QueryClientProvider client={queryClient}>
        <MantineProvider theme={theme}>
          <BrowserRouter>
            <ScrollToTop />
            <App />
            <Toaster position="bottom-left" />
          </BrowserRouter>
        </MantineProvider>
      </QueryClientProvider>
    </JotaiProvider>
  </React.StrictMode>,
);
